import { FC, ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../Footer";
import Header from "../Header";

interface PageProps {
  meta: {
    title: string;
    description: string;
    canonical?: string;
  };
  children?: ReactNode;
  pageClass?: string;
}

const Page: FC<PageProps> = ({ meta, children, pageClass = "" }) => {
  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        {meta.canonical && <link rel="canonical" href={meta.canonical} />}
      </Helmet>

      <div className={`page-container ${pageClass}`}>
        <Header />

        <main>{children}</main>

        <Footer />
      </div>
    </>
  );
};

const withPage =
  (Component: FC) => (pageProps: Omit<PageProps, "children">) => () => (
    <Page {...pageProps}>
      <Component />
    </Page>
  );

export default withPage;
